import styled, { css } from 'styled-components';
import { colors } from 'style/theme';

export const NewPasswordInputStyle = css`
  background: ${colors.pickledBluewoodLight4};
  border-radius: 16px;
  padding: 8px 12px;
  font-size: 16px;

  > input {
    font-family: Inter;
    border: none;
    font-size: 16px;
    font-style: normal;
    color: ${colors.pickledBluewood};
    font-weight: 400;
    line-height: 24px;
    margin: 0;
    padding: 0;
  }

  > label {
    font-family: Inter;
    color: ${colors.pickledBluewoodLight2};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    > svg {
      display: none;
    }

    > span {
      font-size: 12px;
    }
  }
`;

export const Toggle = styled.div`
  color: ${colors.pickledBluewood};
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
  position: absolute;
  right: 12px;
  bottom: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
